export default __webpack_public_path__ + "static/media/download_icon.e404fa30.svg";